$(function(){
  var cMaster = 'data-js-pulldown';
  var cBtn = 'data-js-pulldown__btn';
  var vBtn = $('[' + cBtn + ']');
  var cContents = 'data-js-pulldown__contents';
  $(vBtn).click(function() {
    $(this).slideUp().closest('[' + cMaster + ']' ).find('[' + cContents + ']').slideDown();
  })
});
